<script>

	import Profile from './Profile.svelte';
	import HBCU from './HBCU.svelte';
	import HBCU2 from './HBCU2.svelte';

	import { auth, googleProvider } from './firebase.config.js';
    import { authState } from 'rxfire/auth';
	import Box from './Box.svelte'

	let version = "0.64"
//	export let name;

	let user;

//	$: xxx = auth;
//	$: console.log(xxx);

	//$: console.log(myuser)

	$: unsubscribe = authState(auth).subscribe(u => user = u);


	function login() {

		auth.signInWithPopup(googleProvider);

	}

</script>

<div class="container container-fluid">
<div class="row">

	
		{#if user}

		<div class="card" style="width: 18rem;">
			<div class="card-body">
			  <h3 class="card-title">HBCU List {version}</h3>
			  <hr>
			  <p class="card-text">
				Historically black colleges and universities (HBCUs) are institutions of higher education in the United States that were established before the Civil Rights Act of 1964 with the intention of primarily serving the African-American community. Most of these institutions were founded in the years after the American Civil War and are concentrated in the Southern United States.
			  </p>
			  

			 
			</div>
		  </div>

		<!--<Profile {...user} />
		<hr>
		<button on:click={ () => auth.signOut()}> Logout</button>
		<button>This Rocks!</button>-->
	 
			<div class="card" style="width: 18rem;">
				<div class="card-body">
				  
				  <Profile {...user} />
	
				  <button class="btn btn-primary" on:click={ () => auth.signOut()}> Logout</button>
				</div>
			  </div>
	
	
	
		{:else}
		<div class="card" style="width: 18rem;">
			<div class="card-body">
			  <h5 class="card-title">HBCU List {version}</h5>

			  <p class="card-text">To view the HBCU {version} List...</p>
			   <button class="btn btn-primary" on:click={login}> Signin with Google</button> 

			</div>
		  </div>

			
		{/if}
	






</div>

{#if user}

<div class="row">
	<HBCU2/>
</div>
	


{/if}

</div>

